import { Box, IconButton, } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { setState } from "../analyzeSlice";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import GridOnIcon from "@mui/icons-material/GridOn";
import { exportFile_QuotaDetails } from "../analyzeSlice";
import Alert from "../../../components/ui/Alert";

export default function Table() {
	const state = useSelector((store) => store.analyze);
	const dispatch = useDispatch();
	const {
		quotaDetailsDataPrepared,
		duration,
		selectedCountry,
		selectedCountryID,
		selectedCustomerName,
		selectedCustomerID,
		listQuotaDetails,
	} = state;
	const { rows, columns } = quotaDetailsDataPrepared;
	const [rowSelectionModel, setRowSelectionModel] = React.useState([]);
	const [paginationModel, setPaginationModel] = useState({
		pageSize: 20,
		page: 0
	});
	const [alert, setAlert] = useState({
		alertSeverity: "",
		alertDisplay: false,
		alertMessage: ""
	})


	let listDetails = rows.filter((item) => {
		if (rowSelectionModel.includes(item.id)) {
			return {
				SKUNumber: item.SKUNumber,
				SKUorPGName: item.SKUorPGName,
				quota: item.quota,
				scenarioName: item.scenarioName
			}
		}
	});
	//dispatch(setState("listQuotaDetails", listDetails));
	
	const displayAlert = (severityType) => {
		setAlert({
			"alertSeverity": "warning",
			"alertDisplay": true,
			"alertMessage": `${severityType}`
		});

		setTimeout(() => {
			clearAlert();
		}, [3000])

	}

	const clearAlert = () => {
		setAlert({
			"alertSeverity": "",
			"alertDisplay": false,
			"alertMessage": ``
		});
	}


	function exportDataAsFile(isPdf) {
		if (rowSelectionModel.length > 0) {
			const customerId = selectedCustomerName.customerID;
			const clientCustomerCode = selectedCustomerName.clientCustomerCode;
			const customerName =
				selectedCustomerName.customerName + " | " + clientCustomerCode;

			const postData = {
				isPdf,
				CountryID: selectedCountryID,
				CountryName: selectedCountry,
				//   CustomerIds: selectedCustomerID,
				//   CustomerName: selectedCustomerName,
				CustomerIds: customerId,
				CustomerName: customerName,
				DurationForQuotaDetails: duration,
				AnalyzeTitle: "Quota Details",
				listAnalyseData: listDetails,
			};
			dispatch(exportFile_QuotaDetails(postData));
		}
		else {
			displayAlert("Please select the checkboxes to download the data!")
		}
	}

	console.log(listDetails);

	return (
		<Box>
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					justifyContent: "flex-start",
					justifyContent: "flex-end",
				}}
			>
				<IconButton onClick={(e) => exportDataAsFile(false)}>
					<GridOnIcon sx={{ color: "green.main" }} />
				</IconButton>
				<IconButton onClick={(e) => exportDataAsFile(true)}>
					<PictureAsPdfIcon sx={{ color: "red.main" }} />
				</IconButton>
			</Box>

			<DataGrid
				rows={rows}
				columns={columns}
				getRowId={row => row.id}
				paginationModel={paginationModel}
				onPaginationModelChange={setPaginationModel}
				pageSizeOptions={[20, 50, 100]}
				checkboxSelection={true}
				disableRowSelectionOnClick
				onRowSelectionModelChange={(newRowSelectionModel) => {
					console.log(newRowSelectionModel)
					setRowSelectionModel(newRowSelectionModel);
				}}
				disableColumnMenu
			/>
			{alert.alertDisplay && <Alert message={alert.alertMessage} severity={alert.alertSeverity} />}
		</Box>
	);
}
